import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { Container, Logo, btn } from '../components/landing/shared';
import { useSiteConfig } from '../lib/siteConfig';

export default function DankeBewerbung() {
  const { state } = useLocation();
  const { checklist_url, brand_name } = useSiteConfig();
  const firstName = state?.firstName || sessionStorage.getItem('apply_first_name') || '';

  useEffect(() => { document.title = `Danke für deine Bewerbung | ${brand_name}`; }, [brand_name]);

  return (
    <div className="flex min-h-screen flex-col bg-paper font-sans" data-testid="thanks-page">
      <header className="bg-paper">
        <Container className="flex h-16 items-center sm:h-[72px]"><Logo /></Container>
      </header>
      <main className="flex flex-1 items-center py-16 sm:py-24">
        <Container className="max-w-[720px]">
          <div className="hero-in rounded-[28px] border border-line bg-navy p-7 text-center sm:p-12">
            <CheckCircle2 size={48} strokeWidth={1.5} className="mx-auto text-brand" aria-hidden="true" />
            <h1 className="mt-6 font-display text-4xl font-extrabold leading-tight tracking-tight text-white sm:text-5xl" data-testid="thanks-headline">
              Danke{firstName ? `, ${firstName}` : ''}! Deine Bewerbung ist da.
            </h1>
            <p className="mx-auto mt-5 max-w-lg text-base leading-relaxed text-ink sm:text-lg">
              Ich melde mich innerhalb von 48 Stunden persönlich per WhatsApp oder Anruf. Bis dahin: Hol dir schon mal meine kostenlose Aktien-Checkliste.
            </p>
            <a href={checklist_url} className={`${btn.primary} mt-8`} data-testid="thanks-checklist-btn">Checkliste holen</a>
            <p className="mt-6">
              <Link to="/" className="rounded text-sm font-semibold text-brand underline underline-offset-4 hover:text-brand-dark" data-testid="thanks-home-link">
                Zurück zur Startseite
              </Link>
            </p>
          </div>
        </Container>
      </main>
    </div>
  );
}
